import DonationsUser from '@/core/components/DonationDetails/DonationsUser/DonationsUser';

export default DonationsUser;
